import React from "react";
import { Wrap } from "./style";
export default function GenericCard({ item }) {
  console.log(item);
  return (
    <Wrap>
      <Wrap.Img>
        <Wrap.Button top="20px" left="20px" background="#0061DF">
          FEATURE
        </Wrap.Button>
        <Wrap.Button top="20px" right="20px">
          FOR SALE
        </Wrap.Button>
        <Wrap.HeroImg />
      </Wrap.Img>
      <Wrap.Details>
        <Wrap.Title>{item?.name || "No Title"}</Wrap.Title>
        <Wrap.Descrpt>{item?.address || "No Address"}</Wrap.Descrpt>
        <Wrap.Features>
          <Wrap.Item>
            <Wrap.Beds />
            <div>
              {item?.houseDetails?.room ? item?.houseDetails?.room : "0"}
              Beds
            </div>
          </Wrap.Item>
          <Wrap.Item>
            <Wrap.Bath />
            <div>
              {item?.houseDetails?.bath ? item?.houseDetails?.bath : "0"}
              Baths
            </div>
          </Wrap.Item>
          <Wrap.Item>
            <Wrap.Car />
            <div>
              {item?.houseDetails?.garage
                ? item?.houseDetails?.garage
                : "No Garage"}
            </div>
          </Wrap.Item>
          <Wrap.Item>
            <Wrap.Ruler />
            <div>
              {item?.houseDetails?.area ? item?.houseDetails?.area : "0"} Sq Ft
            </div>
          </Wrap.Item>
        </Wrap.Features>
        <Wrap.Footer>
          <span>${item?.price}/mo</span>
          <span>
            <Wrap.ReSize /> <Wrap.Plus /> <Wrap.Heart />
          </span>
        </Wrap.Footer>
      </Wrap.Details>
    </Wrap>
  );
}
